import axios from 'axios';
import {CONFIG, URLS} from '../helpers/Common';


export const SURGEON = {
    login,
    getPendingPatientsNarrative,
};

function getPendingPatientsNarrative(surgeon_id) {
    let data = new FormData();
    data.append('surgeon_id',surgeon_id);
    let requestOptions = {
        method:'POST',
        data,
        url:`${CONFIG.API_URL+URLS.pending_patient_narratives}`
    };

    return axios(requestOptions).then(res => {
        return res;
    }).catch(err => {
        return err;
    });
 }
 
function login(userData)
{
    let data = new FormData();
    data.append('email',userData.email);
    data.append('password',userData.password);
    let requestOptions = {
        method:'POST',
        data,
        url:`${CONFIG.API_URL+URLS.login}`
    };

    return axios(requestOptions).then(res => {
        return res;
    }).catch(err => {
        return err;
    });
}

